import { defineComponent, toRef, reactive, computed, ref, provide, createElementBlock, openBlock, normalizeStyle, normalizeClass, createBlock, createCommentVNode, createVNode, withCtx, renderSlot, TransitionGroup } from 'vue';
import { useFocusState } from './basler-components.es442.js';
import { tabsInjectionKey } from './basler-components.es424.js';
import _sfc_main$1 from './basler-components.es105.js';
/* empty css                        */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabsComponent",
  props: {
    title: { default: "" },
    tabListPosition: { default: "top" },
    tabListIsFullwidth: { type: Boolean, default: false },
    tabListHorizontalWidth: {},
    state: {}
  },
  emits: ["tab-change"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const externalState = toRef(props, "state");
    const internalState = reactive({
      title: props.title,
      tabs: []
    });
    const tabsState = computed(() => {
      return externalState.value ? externalState.value : internalState;
    });
    const addTab = (tab) => {
      tabsState.value.tabs.push(tab);
    };
    const deleteTab = (computedId = "") => {
      const tabIndex = tabsState.value.tabs.findIndex((tab) => tab.computedId === computedId);
      if (tabIndex > -1) {
        tabsState.value.tabs.splice(tabIndex, 1);
      }
    };
    const findTab = (tabId) => {
      return tabsState.value.tabs.find((tab) => tab.computedId === tabId);
    };
    const selectTab = (tabId) => {
      const selectedTab = findTab(tabId);
      if (!selectedTab || selectedTab.isActive) {
        return;
      }
      emit("tab-change", selectedTab);
      tabsState.value.tabs.forEach((tab) => {
        tab.isActive = tab.computedId === tabId;
      });
    };
    const tabsRef = ref(null);
    const { onElementKeydown } = useFocusState(
      tabsRef,
      ".tab-list__item",
      props.tabListPosition === "left" ? "vertical" : "horizontal"
    );
    const tabListHorizontalWidth = computed(() => {
      const width = void 0;
      if ((props.tabListPosition === "left" || props.tabListPosition === "right") && props.tabListHorizontalWidth) {
        return `${props.tabListHorizontalWidth}%`;
      }
      return width;
    });
    provide(tabsInjectionKey, {
      tabsState: tabsState.value,
      addTab,
      deleteTab,
      selectTab,
      onElementKeydown
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "tabsRef",
        ref: tabsRef,
        class: normalizeClass(["tabs", `has-tablist-${_ctx.tabListPosition}`]),
        style: normalizeStyle({ ["--tab-list-horizontal-width"]: tabListHorizontalWidth.value })
      }, [
        ["top", "left"].includes(_ctx.tabListPosition) ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          "tab-list-is-fullwidth": _ctx.tabListIsFullwidth
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "tab-list-additional-content")
          ]),
          _: 3
        }, 8, ["tab-list-is-fullwidth"])) : createCommentVNode("", true),
        createVNode(TransitionGroup, {
          name: "tabs-switch",
          tag: "div",
          class: "tabs__panels"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }),
        ["bottom", "right"].includes(_ctx.tabListPosition) ? (openBlock(), createBlock(_sfc_main$1, {
          key: 1,
          "tab-list-is-fullwidth": _ctx.tabListIsFullwidth
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "tab-list-additional-content")
          ]),
          _: 3
        }, 8, ["tab-list-is-fullwidth"])) : createCommentVNode("", true)
      ], 6);
    };
  }
});

export { _sfc_main as default };
